var React = require('react');

function IconAngularJs (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"icomoon-ignore","key":0}),React.createElement("path",{"fill":"#e23237","d":"M29.013 168.96l476.16-168.96 489.813 167.253-78.507 629.76-411.307 226.987-402.773-223.573-73.387-631.467z","key":1}),React.createElement("path",{"fill":"#b52e31","d":"M994.987 167.253l-489.813-167.253v1024l409.6-226.987 80.213-629.76z","key":2}),React.createElement("path",{"fill":"#fff","d":"M506.88 119.467v0l-296.96 660.48 110.933-1.707 59.733-148.48h266.24l64.853 150.187 105.813 1.707-310.613-662.187zM506.88 331.093l100.693 209.92h-187.733l87.040-209.92z","key":3})]);
}

IconAngularJs.defaultProps = {"version":"1.1","width":"1024","height":"1024","viewBox":"0 0 1024 1024"};

module.exports = IconAngularJs;

IconAngularJs.default = IconAngularJs;
